import {inject, Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {map, of} from "rxjs";
import {ResponseHttpSuccess} from "library";
import {environment} from "projects/store/src/environments/environment";
import {AuthService} from "./auth.service";

@Injectable({
  providedIn: 'root'
})
export class CategoryRequestService {

  private apiUrl: string = environment.salesAPIURL;
  private http = inject(HttpClient);
  private authService = inject(AuthService)

  getProductsByCategory(categoryId: string) {
    return this.http.get<ResponseHttpSuccess>(`${this.apiUrl}category/${categoryId}/products`, this.authService.getHttpOptionsBearer())
      .pipe( map( (resp: any) => resp as ResponseHttpSuccess))
  }

  simulateCredit(categoryId: string, data: any) {
    return this.http.post(`${this.apiUrl}category/${categoryId}/simulator`, data, this.authService.getHttpOptionsBearer())
      .pipe( map((resp: any) => resp as ResponseHttpSuccess) );
  }

  simulateCreditForModal(requestId: string, data: any) {
    return this.http.post(`${this.apiUrl}request/${requestId}/simulator`, data, this.authService.getHttpOptionsBearer())
      .pipe( map((resp: any) => resp as ResponseHttpSuccess) );
  }

  createCategoryRequest(categoryId: string, data: any) {
    return this.http.post(`${this.apiUrl}category/${categoryId}/request`, data, this.authService.getHttpOptionsBearer())
      .pipe( map((resp: any) => resp as ResponseHttpSuccess) )
  }
}
